var _circle, _circle2, _circle3, _circle4, _circle5, _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGodot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "godotTitle"
  }, "Godot") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "godotTitle"
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 56,
    fill: "#4e95d8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 44,
    r: 8,
    fill: "#ffffff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 44,
    r: 8,
    fill: "#ffffff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 44,
    r: 3,
    fill: "#1c2a39"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 44,
    r: 3,
    fill: "#1c2a39"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 70,
    width: 60,
    height: 12,
    rx: 6,
    fill: "#1c2a39"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 52l-6 10h12z",
    fill: "#1c2a39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 30l12-10m68 10L88 20",
    stroke: "#1c2a39",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGodot);
export default __webpack_public_path__ + "static/media/godot.74dcaf28dbdfa79b960d7ccd5d8f6999.svg";
export { ForwardRef as ReactComponent };